<h2 matDialogTitle>Backend Error</h2>
<mat-dialog-content>{{errorMessage}}</mat-dialog-content>
